import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter
import HttpServices from './api/service/HttpServices'
import appConstants from './utils/helper/appConstants'
import logUtils from './utils/helper/logUtils'
import dateHelper from './utils/helper/dateHelper'
import validatorHelper from './utils/helper/validatorHelper'
import { STable, Ellipsis } from '@/components'
import DetailList from '@/components/tools/DetailList'
import { CustomPageTable, SearchHeader, SearchCombinationButton, SearchPageView, CustomImage } from '@/customComponents'
import dbManager from '@/utils/indexeDb'
//使用全局组件
Vue.component('s-table', STable)
Vue.component('ellipsis', Ellipsis)
Vue.component('DetailList', DetailList)
Vue.component('DetailListItem', DetailList.Item)

Vue.component('CustomPageTable', CustomPageTable)
Vue.component('SearchHeader', SearchHeader)
Vue.component('SearchList', SearchHeader.SearchList)
Vue.component('SearchCombinationButton', SearchCombinationButton)
Vue.component('SearchPageView', SearchPageView)
Vue.component('CustomImage', CustomImage)
Vue.use(VueAxios)

//定义全局变量
//全局常量
Vue.prototype.getAppConstants = () => appConstants

Vue.prototype.getAppConfig = () => store.getters.appConfig//项目配置信息
Vue.prototype.getPlatformConfig = () => store.getters.platformConfig//平台配置参数
Vue.prototype.getValidatorHelper = () => validatorHelper
//日志统一服务
let unifiedLog = undefined
Vue.prototype.getLogUtils = () => {
  if (unifiedLog === undefined) {
    let appConfig = store.getters.appConfig
    unifiedLog = new logUtils(appConfig.isDev || appConfig.debug)
    unifiedLog.logWithTag('initLogUtils', unifiedLog)
  }
  return unifiedLog
}
//去除H5页面缓存函数
Vue.prototype.clearH5Cache = function() {
  let appConfig = store.getters.platformConfig
  const url = appConfig.h5Url + '/clear/cache'
  let frameElement = document.createElement('iframe')
  frameElement.src = url
  frameElement.setAttribute('style', 'width:100%;height:0px;')
  frameElement.onload = () => {
    // console.error("=========页面缓存清除完成===============")
    document.body.removeChild(frameElement)
    // console.error("=========页面清除完成===============")
  }
  document.body.appendChild(frameElement)
}
//网络接口服务
Vue.prototype.getHttpServices = () => HttpServices //网络接口服务
Vue.prototype.getDateHelper = () => dateHelper
Vue.config.productionTip = false
import Mixin from './mixins'

Vue.mixin(Mixin)// 使用全局扩展

Vue.prototype.dbManager = dbManager // 全局挂在操作dbManager
const dbName = 'vueDB', personObjectStore = 'GlobalCity'

new Vue({
  router,
  store,
  async created() {
    await bootstrap()
    // 创建数据库
    await this.dbManager.createOrOpenDb(dbName, 1)
    // 创建对象结构
    await this.dbManager.createObjectStore(personObjectStore, {
      keyPath: 'id',
      cityList: false
    })
    // 创建对象结构所属的方法
    await this.dbManager.createObjectStoreOperations(personObjectStore)
  },
  render: h => h(App)
}).$mount('#app')
